<template>
  <div>
    <transition-group
      :class="layoutClass"
      class="search-results"
      name="list"
      appear
      @enter="enter"
      @leave="leave">
      <div
        v-for="( result, index ) in results"
        :key="result.id"
        :class="columnsClass"
        :data-index="index"
        class="search-result">
        <component
          :is="resultTemplates[activeResultTemplate]"
          :key="result.id"
          v-bind="result"
          :layout="layout">
        </component>
      </div>
    </transition-group>

    <span
      v-if="results == null || results.length === 0"
      class="no-results">
      No results found
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { TweenMax } from "gsap";

export default {
  props: {
    columns: {
      type: Number,
      default: 3,
      required: false
    }
  },
  data () {
    return {
      resultTemplates: {
        default: () => import( "~/Components/Search/Results/Default.vue" ),
        list: () => import( "~/Components/Search/Results/List.vue" ),
        testimonials: () => import( "~/Components/Search/Results/Testimonials.vue" )
      }
    };
  },
  computed: {
    columnCount () {
      let columnCount = 1;

      if ( this.columns > 0 ) {
        columnCount = this.columns;
      } else if ( this.stateColumnCount > 0 ) {
        columnCount = this.stateColumnCount;
      }

      return columnCount;
    },
    layoutClass () {
      return `layout-${this.layout}`;
    },
    columnsClass () {
      return `cols-${this.columnCount}`;
    },
    ...mapState( {
      configNode: state => state.search.configNode,
      filters: state => state.search.filters,
      results: state => state.search.results,
      layout: state => state.search.layout,
      stateColumnCount: state => state.search.columnCount,
      activeResultTemplate: state => state.search.activeResultTemplate
    } )
  },
  methods: {
    enter ( el, done ) {
      const delay = ( el.dataset.index * 0.05 ) + 0.3;

      el.style.opacity = 0;
      TweenMax.killTweensOf( el );

      TweenMax.to(
        el,
        0.2,
        { opacity: 1, delay, onComplete: done }
      );
    },
    leave ( el, done ) {
      TweenMax.killTweensOf( el );

      TweenMax.to(
        el,
        0.2,
        { opacity: 0, onComplete: done }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.search-results {
  box-sizing: border-box;
  margin-bottom: 10px;
  display: flex;
  padding: 5px;
  flex-wrap: wrap;

  .search-result {
    margin: 5px;
    box-sizing: border-box;
    transition: height 0.5s;
  }
}

.no-results {
  display: block;
  text-align: center;
  margin: 20px 0;
  width: 100%;
}

.search-results.layout-grid {
  .search-result {
    .loop(6);

    @media ( max-width: 991px ) {
      width: 100% !important;
      flex-basis: 100% !important;
    }
  }
}

.search-results.layout-row {
  .search-result {
    flex-basis: ~"calc(100% - 10px)";
  }
}

.generate-search-result( @perRow ) {
  @percentage: 100 / @perRow;

  flex-basis: ~"calc(@{percentage}% - 10px)";
}

.loop( @counter ) when ( @counter > 0 ) {
  .loop( ( @counter - 1 ) );    // next iteration

  &.cols-@{counter} {
    .generate-search-result( @counter ) // code for each iteration
  }
}
</style>
